<template>
	<div>
		<q-dialog v-model="importfile" persistent transition-show="fade" transition-hide="fade">
			<div class="hris-modal" style="max-width: 420px;">
				<q-form ref="form" autocomplete="off" @submit="onSubmit">
					<div class="hris-modal-header">
						<div>
							<h2 class="hris-modal-title">Select File</h2>
							<p class="hris-modal-subtitle">Choose a file to import.</p>
						</div>
					</div>
					<div class="hris-modal-body">
						<input type="file" id="file" ref="file" :rules="[ val => val && val.length > 0 || 'This field is required!']"  v-on:change="handleFileUpload()" required />
					</div>
					<div class="hris-modal-footer">
						<q-btn unelevated class="hris-q-ghost" label="Close" @click="closeModal"></q-btn>
						<q-btn unelevated class="hris-q-primary" label="Submit" type="submit"></q-btn>
					</div>
				</q-form>
			</div>
		</q-dialog>

		<q-dialog v-model="spinner" persistent>
			<div class="hris-loading" style="background: transparent; min-width: 200px;">
				<q-spinner color="green" size="3em"></q-spinner>
			</div>
		</q-dialog>
	</div>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';

export default {

	data() {
		return {
			importfile:false,
			file:'',
			spinner:false,
		}
	},
	created(){
		this.eventHub.$on('importFileDialog', this.importFile);
	},

	methods: {

		importFile:function(payload){
			this.importfile = payload.status
		},

		onSubmit:function(){
			this.spinner = true
			let formData  = new FormData();
			formData.append("files", this.file);
			axios({
				onUploadProgress: uploadEvent => {
					console.log("Progress: " + Math.round(uploadEvent.loaded / uploadEvent.total * 100) + '%')
				},
				headers : {'Authorization' : `Bearer ${this.token}`},
				url:this.apiUrl+'/mobile/pantry/trainee/import',
				data: formData,
				method: 'POST'
			}).then(response => {
				console.log(response)
				setTimeout(() => {
					this.spinner = false
					this.importfile = false
				},500)
				this.eventHub.$emit('refreshList');
				this.$q.notify({
					message: 'Successful',
					color: 'green',
					position:'center',
					actions: [
				{ label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
				]
			})
			}).catch((error) => {
				var message = error.response.data.exception[1].message
				var index = message.indexOf("1062");
				var final = message.substring(index + 4);
				this.$q.notify({
					message: final,
					color: 'negative',
					position:'center',
					actions: [
				{ label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
				]
			})
				this.spinner = false
			})
		},
		handleFileUpload(){
			this.file = this.$refs.file.files[0];
		},

		closeModal:function(){
			this.importfile = false
		}
	}
}
</script>
<style lang="css" scoped>
</style>
